
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'

export default {
data() {
return {
devseq: "",
devname: "",
devmodel: '',
producer: '',
buyfrom: "",
company: '',
ftype: '',
name: '',
mobile: '',
fdesc: "",
imgList: [],
size: 0,
starttime: '',
endtime: '',
photo: {'path': '', 'serverid': ''},
account: '',
username: '',
sequence: '',

title: '默认为空',
value_0_1: [],
value: [],
title2: '设置值',
value2: ['天津市', '市辖区', '和平区'],
value3: ['广东省', '中山市', '--'],
addressData: ChinaAddressV4Data,
value4: [],
value5: ['广东省', '深圳 市', '南山区'],
showAddress: false,
address: [],
address2: '',
obj: {},
list: [],
num: 6,
show: true,
newobj: {
photo: []
},
index: 0,
flag: true,
repair: this.$route.params.repair
}
},
components: {
XHeader,
XInput,
Group,
XAddress,
Card,
Alert,
Cell,
XButton
},
methods: {
fileDel(val, key) {
var index
for (let j = 0; j < this.imgList.length; j++) {
if (this.imgList[j].path == key) {
this.imgList.splice(j, 1)
}
}

for (let i = 0; i < this.list.length; i++) {
if (this.list[i] == key) {
index = i
this.list.splice(i, 1)
this.num++
this.index--
}
}
this.newobj.photo.splice(index, 1)
if (this.num < 6) {
this.show = true
}
},
confirm() {
var obj = {
path: this.list
}
var list = []
list.push(obj)
this.obj.fdetail = list
this.$router.push({name: 'faultType', params: {obj: this.obj, repair: this.repair}})
},
upload() {
var obj = {
photo: []
}

wx.chooseImage({
count: this.num, // 默认9
sizeType: ['compressed'],
sourceType: ['album', 'camera'],
success: (res) => {
var localIds = res.localIds 
var i = 0;
length = localIds.length;
var upload = () => {
wx.uploadImage({
localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: (res) => {

this.$vux.loading.show({
text: 'Loading'
})
this.flag = false
if (!this.list || this.list.length === 0) {
this.newobj.photo.push(res.serverId)
} else {
obj.photo.push(res.serverId)
}
i++
this.num--
if (i < length) {
upload()
} else {
if (!this.list || this.list.length === 0) {
this.submitImage(this.newobj)
} else {
this.submitImage(obj)
}
}
},
fail: (error) => {
console.log(error)
}
})
}
upload()
},
fail: (error) => {
console.log(error)
}
})
},
submitImage(userInfo) {
AjaxPlugin.$http.post('/api/v1/photos/wechat', userInfo)
.then((response) => {
this.flag = true
this.list = [...this.list,...response.data]
this.decrypt()
/*
if (this.list.length === 0) {
response.data.forEach(item => {
this.list.push(item.thumb.toString())
})
this.decrypt()
} else {
for (let i = 0; i < response.data.length; i++) {
this.list.push(response.data[i].thumb.toString())
}
this.decrypt()
}
*/
if (this.list.length === 6) {
this.show = false
}
})
.catch((error) => {
this.flag = true
alert(error)
if (error.response) {
if (error.response.data.error_message) {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
} else {
this.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
} else {
this.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
})
},
decrypt() {
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
var that = this
AjaxPlugin.$http.get('api/v1/photos?path=' + this.list[this.index]['thumb'])
.then(res => {
that.imgList.push(res.data)
that.index++
this.$vux.loading.hide()
if (that.index < that.list.length) {
that.decrypt()
}
})
}

},







mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
app.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then((response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
beforeRouteEnter(to, from, next) {
if (from.name == 'faultType') {
next(vm => {
var arr = []
var brr = []
var index = 0
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
vm.obj = vm.$route.params.obj
var length = vm.$route.params.obj.fdetail.length
if (length > 0) {
arr = vm.$route.params.obj.fdetail[0].path
if (arr.length == 6) {
vm.show = false
}
vm.index = arr.length
vm.num = 6 - arr.length

vm.list = arr
var decrypt = function () {
AjaxPlugin.$http.get('api/v1/photos?path=' + arr[index])
.then(res => {
brr.push(res.data)
index++
if (index < arr.length) {
decrypt()
}
})
}
decrypt()
vm.imgList = brr
}

console.log(vm.obj)
})
} else {
next(vm => {
var obj = localStorage.getItem('obj')
vm.obj = JSON.parse(obj)
console.log(vm.obj)
})
}
},
beforeRouteLeave(to, from, next) {
if (to.name === 'faultType') {
to.params.repair = this.repair;
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/photo.vue